import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../utils/styles';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string; label: string }[];
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, error, id, options, placeholder, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={id} className="text-sm font-bold text-neutral-700">
            {label}
          </label>
        )}
        <select
          id={id}
          className={cn(
            'h-11 rounded-xl border-[0.5px] border-white/30 bg-white/40 backdrop-blur-[20px] px-3 text-base text-neutral-900 transition-all',
            'focus:bg-white/60 focus:border-primary-400/50 focus:outline-none focus:ring-2 focus:ring-[#3CB0DB]/20',
            'disabled:cursor-not-allowed disabled:bg-neutral-100/50 disabled:text-neutral-400',
            error && 'border-red-500 focus:border-red-500',
            className
          )}
          ref={ref}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {error && <p className="text-sm font-bold text-red-600">{error}</p>}
      </div>
    );
  }
);

Select.displayName = 'Select';
